import { responsiveVariables } from "../../utilities/props.js";
import "./justify.css";
const getJustifyStyles = (value) => {
    if (!value)
        return null;
    return {
        variables: responsiveVariables("--rs-justify", value),
    };
};
export default getJustifyStyles;
